import React from 'react';
import styles from './styles.module.scss';

import StyledLink from 'components/StyledLink';
import { FormServerAssetSearch } from 'components/FormComponents';

import { FormProvider, useForm } from 'react-hook-form';

import { ASSET_DETAILED_PATH } from 'constants/routeConstants';

import EditableContent from '../EditableContent';

export default function TruckOrTrailerCellContent({ row, onEdit, isEditable }) {
  const { truck } = row;

  const methods = useForm({
    defaultValues: {
      truck
    }
  });
  const { setValue, getValues } = methods;

  const setDefaultValue = () => setValue('truck', truck);

  const selectTruck = (name, value) => setValue(name, value);

  const handleAcceptClick = () => {
    onEdit({ ...row, truck: getValues('truck') });
  };

  return (
    <EditableContent
      hoverPencil
      onAccept={handleAcceptClick}
      isEditable={isEditable}
      setDefaultValue={setDefaultValue}
      renderDisplayedComponent={() => (
        <StyledLink
          to={`${ASSET_DETAILED_PATH}/${truck.id}`}
          isRedirectAvailable={truck?.id && truck?.id > 0}
          className={styles.drCode__link}>
          {truck?.drCode || '\u2000'}
        </StyledLink>
      )}
      renderEditor={() => (
        <FormProvider {...methods}>
          <FormServerAssetSearch
            name="truck"
            getLabel={(option) => option?.drCode || ''}
            getQuery={(searchQuery) => ({
              pagination: { limit: 39, page: 1 },
              filters: {
                isDeleted: false,
                includeThirdPartyTruck: true,
                equipmentIds: [9, 10],
                searchQuery
              }
            })}
            onSelect={selectTruck}
            className={styles.drCode__field}
          />
        </FormProvider>
      )}
    />
  );
}
